import { AuthState } from "@/entities/auth/auth.model"
import { AssistantCompletionMonitor } from "@/features/assistant/completion-notification-monitor"
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router"
import { TanStackRouterDevtools } from "@tanstack/router-devtools"

interface RouterContext {
  auth: AuthState
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <>
      <Outlet />
      <AssistantCompletionMonitor />
      {import.meta.env.MODE === "development" && (
        <TanStackRouterDevtools position="bottom-right" />
      )}
    </>
  ),
})
